import { render } from "./Waline.vue?vue&type=template&id=39a65ac4&ts=true"
import script from "./Waline.vue?vue&type=script&lang=ts"
export * from "./Waline.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/lizheming/Desktop/workspace/waline/waline/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__